import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCard = ({ icon, title, value, change, changeType, iconBgColor, iconColor }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 transition-smooth hover:shadow-card">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-3">
            <div className={`w-12 h-12 rounded-lg ${iconBgColor} flex items-center justify-center`}>
              <Icon name={icon} size={24} color={iconColor} />
            </div>
          </div>
          <p className="text-sm text-muted-foreground mb-1">{title}</p>
          <p className="text-3xl font-semibold text-foreground">{value}</p>
        </div>
        {change && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-md ${
            changeType === 'positive' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
          }`}>
            <Icon name={changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span className="text-xs font-medium">{change}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;